<template>
    <div>
        <v-row class="mt-1">
            <v-col v-for="(com, index) in companies" :key="index" cols="2">
                <v-card>
                    <v-card-title class="d-flex flex-column justify-center">
                        <v-icon> mdi-home-city-outline </v-icon>
                        <h4 >
                            {{ com.name }} 
                        </h4>
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    data () {
        return {
            companies: [
                {
                    name: 'Cairo'
                },
                {
                    name: 'Cairo'
                },
                {
                    name: 'Cairo'
                },
                {
                    name: 'Cairo'
                },
                {
                    name: 'Cairo'
                },
                {
                    name: 'Cairo'
                }
            ]
        }
    }
}
</script>
